import { queryClient, apiQueryKey, invalidateApiMutation } from './lib/queryClient';
import { formatDate as format } from './lib/format';
import { differenceInMinutes, subMinutes } from 'date-fns';
import { beginInformationRequest } from './utils/dataLoading';
const { statusContractorSection, serverUrl } = require("./constants")

// const axios = require('axios')
const { auth } = require("./firebase-config")
const { toast } = require("react-toastify")

export const getUrlParams = () => {
    const url = window.location.href.split('?')[1]
    const urlParams = new URLSearchParams(url)
    const paramsObj = Object.fromEntries(urlParams)
    return paramsObj
}

export const getFirebaseDocs = snapshot => {
    var data = []
    for (let row of snapshot.docs) {
        data.push({ id: row.id, ...row.data() })
    }
    return data
}

export const removeTrailingSlash = social => {
    if (social[social.length - 1] === '/') {
        social = social.slice(0, -1);
    }
    return social
}

export const getSeconds = () => parseInt(new Date().getTime() / 1000)


export const randomString = (length = 30) => [...Array(length)].map(() => Math.random().toString(36)[2]).join('')

export const reverseDateString = (date, hasDate) => {
    if (hasDate) {
        return date.split('-')[2] + '/' + date.split('-')[1] + '/' + date.split('-')[0]
    } else {
        return date.split('-')[1] + '/' + date.split('-')[0] + '/' + format(new Date(), 'dd')
    }
}

export const checkEmailInValid = (email) => !email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)

export const sortAlphabetically = (arrayVal, property) => {
    let arrayOriginal = [...arrayVal]
    if (!property) {
        return arrayOriginal.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
    }
    return arrayOriginal.sort((a, b) => a[property].toLowerCase() < b[property].toLowerCase() ? -1 : 1)

}


export const getDropdownValue = (val, options, isMulti) => {
    if (options.length > 0 && val) {

        if (typeof (options[0]) === 'string') {
            if (isMulti) {
                return val.map(r => ({ label: r, value: r }))
            } else {
                const matchingVal = options.find(r => r === val)
                if (matchingVal) {
                    return { label: matchingVal, value: matchingVal }
                }
                return ''
            }

        } else {
            if (isMulti) {
                return val.map(r => options.find(x => x.value === r)).filter(r => r)
            } else {
                const matchingVal = options.find(r => r.value === val)
                if (matchingVal) {
                    return { label: matchingVal.label, value: matchingVal.value }
                }
            }
        }
    }
    return isMulti ? [] : ''
}

export const normalizeTimesheetEmailFrequency = (value) => {
    const normalized = String(value || '').trim().toLowerCase().replace(/\s+/g, '')
    if (!normalized) return ''
    if (normalized === 'everyday' || normalized === 'daily') {
        return 'everyday'
    }
    if (normalized === 'everyweek' || normalized === 'weekly' || normalized === 'week') {
        return 'everyweek'
    }
    if (normalized === 'oncompletion' || normalized === 'completion') {
        return 'oncompletion'
    }
    return normalized
}

export const labourRateBandKeys = [
    'weekdayMorningsRate',
    'weekdayNightsRate',
    'fridayNightRate',
    'saturdayDayRate',
    'saturdayNightRate',
    'sundayDayRate',
    'sundayNightRate',
]

export const createEmptyQuantityRateArray = () => Array(10).fill('')

export const createEmptyLabourRates = (workerTypes = []) => Object.fromEntries(
    labourRateBandKeys.map((band) => [
        band,
        Object.fromEntries((workerTypes || []).map((type) => [type, createEmptyQuantityRateArray()])),
    ])
)

export const normalizeQuantityRateArray = (value) => {
    const source = Array.isArray(value) ? value : []
    return Array.from({ length: 10 }, (_, index) => {
        const entry = source[index]
        return entry === undefined || entry === null ? '' : String(entry)
    })
}

// Flat legacy arrays only ever held Traffic Controller pricing, so they seed that
// row alone. Other worker types stay blank until someone configures them, rather
// than silently inheriting TC rates and then billing at them.
// Mirrors normalizeLabourRateBand in functions/common.js — keep the two in step.
export const LEGACY_RATE_WORKER_TYPE = 'Traffic Controller'

export const normalizeLabourRates = ({ labourRates = {}, legacyRates = {}, workerTypes = [] }) => {
    const normalized = createEmptyLabourRates(workerTypes)
    labourRateBandKeys.forEach((band) => {
        const sourceBand = labourRates?.[band]
        const fallback = normalizeQuantityRateArray(legacyRates?.[band] || [])
        normalized[band] = Object.fromEntries(
            (workerTypes || []).map((type) => {
                const nextValue = sourceBand && typeof sourceBand === 'object' && !Array.isArray(sourceBand)
                    ? sourceBand[type]
                    : undefined
                const seed = type === LEGACY_RATE_WORKER_TYPE ? fallback : []
                return [type, normalizeQuantityRateArray(nextValue || seed)]
            })
        )
    })
    return normalized
}

export const deriveLegacyRatesFromLabourRates = ({ labourRates = {}, fallbackRates = {} }) => {
    const derived = {}
    labourRateBandKeys.forEach((band) => {
        derived[band] = normalizeQuantityRateArray(
            labourRates?.[band]?.['Traffic Controller'] || fallbackRates?.[band] || []
        )
    })
    return derived
}


export const getDropdownLabel = (val, options, isMulti) => {

    if (isMulti) {
        return val && val.map(r => options.find(x => x.value === r)?.label).join(', ')
    }

    return options.find(r => r.value === val)?.label
}



export const getStatusColor = (status) => {
    if (status === statusContractorSection.Invited) {
        return 'white'
    } else if (status === statusContractorSection.Compliant) {
        return 'rgb(7, 148, 79)'

    } else if (status === statusContractorSection.PendingReview) {
        return '#FFA500'
    } else if (status === statusContractorSection.NonCompliant || statusContractorSection.Rejected) {
        return '#FF0000'
    }
}

export const getStatusBgColor = (status) => {
    if (status === statusContractorSection.Invited) {
        return '#004d7270'
    } else if (status === statusContractorSection.Compliant) {
        return 'rgb(236, 248, 236)'
    } else if (status === statusContractorSection.PendingReview) {
        return '#FFA50020'
    } else if (status === statusContractorSection.NonCompliant || statusContractorSection.Rejected) {
        return '#FF000040'
    }
}

export const getQuarterHoursFromTimes = ({
    clockIn,
    clockOut,
    breakMinutes = 0,
    breakIncludedInPay = true,
    minuteOffset = 0,
}) => {
    if (!clockIn || !clockOut) {
        return ''
    }
    const breakValue = Number(breakMinutes) || 0
    const adjustedClockOut = subMinutes(new Date(clockOut), breakIncludedInPay ? 0 : breakValue)
    const minutesWorked = differenceInMinutes(adjustedClockOut, new Date(clockIn)) + (Number(minuteOffset) || 0)
    if (!Number.isFinite(minutesWorked) || minutesWorked <= 0) {
        return ''
    }
    const roundedMinutes = Math.round(minutesWorked / 15) * 15
    return roundedMinutes / 60
}

// Generic wrapper for POST requests
// Track active requests by endpoint
const activeRequests = {}
const createRequestKey = (endpoint, body) => `${endpoint}::${JSON.stringify(body || {})}`

const postWithAuthNetwork = async (endpoint, body) => {
    try {
        const requestKey = `${auth.currentUser?.uid || ''}::${createRequestKey(endpoint, body)}`
        // If there's already a request in progress for this endpoint, return that promise
        if (activeRequests[requestKey]) {
            console.warn(`Request to ${endpoint} with matching payload already in progress, skipping duplicate.`)
            return activeRequests[requestKey]
        }

        const finishInformationRequest = beginInformationRequest(endpoint)
        // Create the request promise and store it before anything is awaited, so a
        // second identical call made at the same moment (a double click) waits for
        // this one instead of sending a second request.
        const requestPromise = (async () => {
            const user = auth.currentUser
            if (!user) {
                toast.error('User not logged in')
                throw new Error('User not logged in')
            }

            const token = await user.getIdToken()
            const res = await fetch(`${serverUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            })

            const contentType = res.headers.get('content-type')
            let data

            if (contentType?.includes('application/json')) {
                data = await res.json()
            } else if (contentType?.includes('application/pdf')) {
                data = await res.text() // Base64 string
            } else if (contentType?.includes('application/octet-stream')) {
                const blob = await res.blob()
                data = URL.createObjectURL(blob)
            } else {
                data = await res.text() // fallback
            }

            if (!res.ok) {
                throw new Error(data?.err || 'Request failed')
            }

            return data
        })()

        // Store the promise so further calls get blocked
        activeRequests[requestKey] = requestPromise

        // Once finished, clean it up
        requestPromise.then(
            () => { delete activeRequests[requestKey]; finishInformationRequest() },
            () => { delete activeRequests[requestKey]; finishInformationRequest() }
        )

        return requestPromise

    } catch (err) {
        console.error('API call failed:', err)
        throw err
    }
}

export const postWithAuth = async (endpoint, body, options = {}) => {
    if (options.uncached && endpoint.startsWith('fetch')) return postWithAuthNetwork(endpoint, body)
    if (!endpoint.startsWith('fetch')) {
        const result = await postWithAuthNetwork(endpoint, body)
        if (!result?.err) await invalidateApiMutation(endpoint, body)
        return result
    }
    if (!auth.currentUser) return postWithAuthNetwork(endpoint, body)
    const queryKey = apiQueryKey(auth.currentUser.uid || 'session', endpoint, body)
    if (options.force) await queryClient.invalidateQueries({ queryKey, exact: true, refetchType: 'none' })
    try {
        return await queryClient.fetchQuery({ queryKey, queryFn: async () => {
            const result = await postWithAuthNetwork(endpoint, body)
            if (result?.err) { const error = new Error(result.err); error.apiResponse = result; throw error }
            return result
        } })
    } catch (error) {
        if (error.apiResponse) return error.apiResponse
        throw error
    }
}

// Track active requests without auth
const activeRequestsNoAuth = {}

export const postWithoutAuth = async (endpoint, body) => {
    try {
        const requestKey = createRequestKey(endpoint, body)
        // Prevent duplicate requests to the same endpoint
        if (activeRequestsNoAuth[requestKey]) {
            console.warn(`Request to ${endpoint} with matching payload already in progress, skipping duplicate.`)
            return activeRequestsNoAuth[requestKey]
        }

        const requestPromise = (async () => {
            const res = await fetch(`${serverUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })

            const contentType = res.headers.get('content-type')
            let data

            if (contentType?.includes('application/json')) {
                data = await res.json()
            } else {
                data = await res.text() // fallback
            }

            if (!res.ok) {
                toast.error('Error occurred')
                throw new Error(data?.err || 'Request failed')
            }

            return data
        })()

        // Store the in-flight request
        activeRequestsNoAuth[requestKey] = requestPromise

        // Cleanup after it finishes (success or error)
        requestPromise.then(
            () => { delete activeRequestsNoAuth[requestKey] },
            () => { delete activeRequestsNoAuth[requestKey] }
        )

        return requestPromise

    } catch (err) {
        console.error('API call failed:', err)
        throw err
    }
}
